import { AxiosInstance } from "axios"
import { NewsItem, RoadmapItem } from "./newsTypes"

type FetchRoadmapParams = Readonly<{
    startDate?: string
    endDate?: string
}>

type FetchPublicRoadmapParams = Readonly<{
    shareToken: string
}>

export type FetchGoPayNewsResponse = Readonly<{
    news: NewsItem[]
}>

export type FetchRoadmapResponse = Readonly<{
    roadmaps: RoadmapItem[]
}>

export enum NewsQuery {
    LIST = "get-gopay-roadmap",
    PUBLIC_LIST = "get-gopay-roadmap-public",
}

export async function fetchGoPayNews({}, axios: AxiosInstance, signal?: AbortSignal): Promise<FetchGoPayNewsResponse> {
    const url = `/system/news/`
    const response = await axios.get(url, {
        signal,
    })

    return response.data
}

export async function fetchRoadmapByPeriod(
    { startDate, endDate }: FetchRoadmapParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchRoadmapResponse> {
    const url = `/system/roadmap/`
    const response = await axios.get(url, {
        params: {
            startDate,
            endDate,
        },
        signal,
    })

    return response.data
}

export async function fetchPublicRoadmap(
    { shareToken }: FetchPublicRoadmapParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchRoadmapResponse> {
    const response = await axios.get(`/public/system/roadmap/${shareToken}`, { signal })

    return response.data
}
